import type { AssetsAssetVersion } from '@iconik-io/iconik-api/src/services/assets';

import type { AssetsAssetVersionSchemaWithIdExtended } from '../redux/entities/selectors/versions';

export function filterVersionsBySelectedVersionIds(
  versions: AssetsAssetVersion[],
  versionIds: string[] | undefined,
): AssetsAssetVersion[] {
  if (!versionIds) {
    return versions;
  }
  return versions.filter((item) =>
    item.id ? versionIds.includes(item.id) && item.status === 'ACTIVE' : false,
  );
}

export function filterExtendedVersionsBySelectedVersionIds(
  versions: AssetsAssetVersionSchemaWithIdExtended[],
  versionIds: string[] | undefined,
): AssetsAssetVersionSchemaWithIdExtended[] {
  if (!versionIds) {
    return versions;
  }
  return versions.filter(
    (item) => versionIds.includes(item.id) && item.status === 'ACTIVE',
  );
}
